var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupoffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5625 17.9689H1.5625C0.703125 17.9689 0 17.2657 0 16.4064V6.25012C0 5.39075 0.703125 4.68762 1.5625 4.68762H26.5625C27.4219 4.68762 28.125 5.39075 28.125 6.25012V16.4064C28.125 17.2657 27.4219 17.9689 26.5625 17.9689ZM3.125 14.8439H25V7.81262H3.125V14.8439Z",
    fill: "#6C757D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 7.8125H18.75V3.125H9.375V7.8125H6.25V1.5625C6.25 0.703125 6.95312 0 7.8125 0H20.3125C21.1719 0 21.875 0.703125 21.875 1.5625V7.8125Z",
    fill: "#6C757D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25H3.125C2.26562 25 1.5625 24.2969 1.5625 23.4375V17.1875H4.6875V21.875H23.4375V17.1875H26.5625V23.4375C26.5625 24.2969 25.8594 25 25 25Z",
    fill: "#6C757D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6255 14.0626H12.5005C11.6375 14.0626 10.938 14.7622 10.938 15.6251V17.1876C10.938 18.0506 11.6375 18.7501 12.5005 18.7501H15.6255C16.4884 18.7501 17.188 18.0506 17.188 17.1876V15.6251C17.188 14.7622 16.4884 14.0626 15.6255 14.0626Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupoffice);
export default __webpack_public_path__ + "static/media/Groupoffice.a9c90d2f22d64b2639149c80ad618ddf.svg";
export { ForwardRef as ReactComponent };